import styled, { css } from 'styled-components';
import { ComponentSize } from '../types';
import { fontSmoothing } from '../../../mixins';
import { variant } from 'styled-system';
import { ThemeUtilities } from '../../../theme';
import { Status, Variant } from './types';

export const StyledTextArea = styled.textarea<{
  size: ComponentSize;
  status: Status;
  fullWidth: boolean;
  variant: Variant;
}>`
  border: 1px solid currentColor;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  ${fontSmoothing};

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `};

  transition: border-color 250ms ease-in-out, box-shadow 250ms ease-in-out,
    background-color 250ms ease-in-out;
  will-change: border-color, box-shadow, background-color;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'TextArea', 'size'))};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'TextArea', 'variant'))};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'TextArea', 'status'))};

  ${css((props) => ThemeUtilities.getComponentCSSOverrides(props, 'TextArea'))};
`;
